import { call } from "redux-saga/effects";

import API from "modules/api/api";
import { setItem } from "modules/local-storage/local-storage-effects";
import { APP_TOKEN_KEY } from "modules/user/user-constants";
import { setAppToken } from "modules/user/user-utils";
import { composeSaga, withErrorHandling } from "modules/root/saga-helpers";

function* fbLoginImpl(token) {
  return yield call(API.user.fbLogin, token);
}
export const fbLogin = fbLoginImpl;

function* loginImpl(name, pass) {
  const resp = yield call(API.user.login, name, pass);
  // axios uses lowercase headers
  const appToken = resp.headers[APP_TOKEN_KEY.toLowerCase()];
  yield call(setAppToken, appToken);
  yield call(setItem, APP_TOKEN_KEY, appToken);
  return resp;
}
export const login = loginImpl;

function* confirmEmailImpl(email, code, consent) {
  return yield call(API.user.confirmEmail, email, code, consent);
}
export const confirmEmail = confirmEmailImpl;

function* resendConfirmEmailImpl(email) {
  return yield call(API.user.resendConfirmEmail, email);
}
export const resendConfirmEmail = composeSaga(
  withErrorHandling,
  resendConfirmEmailImpl
);

function* updatePasswordImpl(email, password, token) {
  return yield call(API.user.updatePassword, email, password, token);
}
export const updatePassword = updatePasswordImpl;

function* signUpUserImpl(...options) {
  return yield call(API.user.signUp, ...options);
}

export const signUpUser = signUpUserImpl;

function* getSsnKeyImlp(...options) {
  return yield call(API.user.getSsnKey, ...options);
}
export const getSsnKey = getSsnKeyImlp;

function* bankIdCollectImlp(...options) {
  return yield call(API.user.bankIdCollect, ...options);
}
export const bankIdCollect = bankIdCollectImlp;



// WEBPACK FOOTER //
// ./src/modules/auth/auth-api-saga.js